// Stage (exact strings from your data)
export type DealStage = 'Deal Won' | 'Contract Sent' | 'Proposal' | 'Contract Created' | 'Pending Approval' | 'Cold'

export const DEAL_STAGE_OPTIONS: { value: DealStage | 'Any'; label: string }[] = [
  { value: 'Any', label: 'All Stages' },
  { value: 'Deal Won', label: 'Deal Won' },
  { value: 'Contract Sent', label: 'Contract Sent' },
  { value: 'Proposal', label: 'Proposal' },
  { value: 'Contract Created', label: 'Contract Created' },
  { value: 'Pending Approval', label: 'Pending Approval' },
  { value: 'Cold', label: 'Cold' },
]

// Deal status
export type DealStatus = 'Active' | 'In Progress' | '30 Day Notice' | 'Replaced' | 'Pending' | 'Cancelled' | 'Ended'

export const DEAL_STATUS_OPTIONS: { value: DealStatus | 'Any'; label: string }[] = [
  { value: 'Any', label: 'All Statuses' },
  { value: 'Active', label: 'Active' },
  { value: 'In Progress', label: 'In Progress' },
  { value: '30 Day Notice', label: '30 Day Notice' },
  { value: 'Replaced', label: 'Replaced' },
  { value: 'Pending', label: 'Pending' },
  { value: 'Cancelled', label: 'Cancelled' },
  { value: 'Ended', label: 'Ended' },
]

// "Role" relative to the viewer (owner vs approver vs team)
export type DealRole = 'owner' | 'approver' | 'team' | 'any' | 'all'
export const DEAL_ROLE_OPTIONS: { value: DealRole; label: string }[] = [
  { value: 'any', label: 'Any' },
  { value: 'owner', label: 'Owned' },
  { value: 'approver', label: 'Approver' },
  { value: 'team', label: 'Team' },
  //   { value: 'any', label: 'Any Match' },
  //   { value: 'all', label: 'All Match' },
]

// (Optional) fix for your TASK options: small label typo
export const TASK_OPTIONS: { value: string; label: string }[] = [
  { value: 'owned', label: 'Owned' },
  { value: 'assigner', label: 'Assigner' },
  { value: 'activeAssignee', label: 'Active Assignee' },
  { value: 'completed', label: 'Completed' }, // <- was "Active Assignee" twice
]
